import * as React from 'react'
// import { Card } from '@/app/features/common/Card'
import clx from 'classnames'

type Props = {
  icon?: React.ReactNode
  description?: string
  className?: string
}

export const EmptyStateCardContent = ({
  icon,
  description,
  className,
}: Props) => {
  return (
    <div
      className={clx(
        'tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-my-16',
        className,
      )}
    >
      {icon}
      {description && (
        <p className="tw-text-sm tw-text-content-secondary">{description}</p>
      )}
    </div>
  )
}
